module.exports = __webpack_public_path__ + "/images/logo-hellobb-isotip.f8f0c46.svg";